import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { gridsQueryKey } from './useGrids'

import type { BaseGrid, Grid, GridVersionPayload, Workspace } from 'honeygrid-types'

interface CreateGridParams {
	workspaceId?: Workspace['uuid']
	grid: BaseGrid & { currentVersion: GridVersionPayload }
}

export const useCreateGrid = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: ({ workspaceId = '', grid }: CreateGridParams) =>
			authFetch(`workspaces/${workspaceId}/grids`, {
				method: 'POST',
				body: grid,
			}) as Promise<Grid>,
		onSuccess: (_, { workspaceId = '' }) => {
			// Invalidate grids list for workspace
			queryClient.invalidateQueries({ queryKey: gridsQueryKey(workspaceId) })
		},
	})
}
